import { createRouter } from "@tanstack/solid-router";
import { NotFoundRoute } from "@/components/not-found-route";
import { rootRoute } from "@/routes/__root";
import { authRoute } from "@/routes/_auth/route";
import { loginRoute } from "@/routes/_auth/login";
import { registerRoute } from "@/routes/_auth/register";
import { forgotPasswordRoute } from "@/routes/_auth/forgot-password";
import { resetPasswordRoute } from "@/routes/_auth/reset-password";
import { verifyEmailRoute } from "@/routes/_auth/verify-email";
import { socialCallbackRoute } from "@/routes/_auth/social-callback";
import { appRoute } from "@/routes/_app/route";
import { indexRoute } from "@/routes/_app/index";
import { profileRoute } from "@/routes/_app/profile";
// §M1 · «Mis perfiles»: qué soy en cada academia y qué desbloquea cada perfil.
import { profilesRoute } from "@/routes/_app/profiles";
import { debugRoute } from "@/routes/_app/debug";
import { organizationsRoute } from "@/routes/_app/organizations";
import { cc21ProbeRoute } from "@/routes/_app/cc21-probe";
import { organizationDetailRoute } from "@/routes/_app/organizations.$orgId";
import { invitationsRoute } from "@/routes/_app/invitations";
import { adminRoute } from "@/routes/_app/admin";
import { adminIndexRoute } from "@/routes/_app/admin.index";
import { adminUsersRoute } from "@/routes/_app/admin.users";
import { adminUserDetailRoute } from "@/routes/_app/admin.users.$userId";
import { adminInvitesRoute } from "@/routes/_app/admin.invites";
import { adminAuditLogRoute } from "@/routes/_app/admin.audit-log";
import { adminIntegrationsRoute } from "@/routes/_app/admin.integrations";
import { adminFeaturesRoute } from "@/routes/_app/admin.features";
import { adminFlagsRoute } from "@/routes/_app/admin.flags";
import { adminMetricsRoute } from "@/routes/_app/admin.metrics";
// B8 · panel del asistente de la academia (deflexión + FAQ).
import { adminAcademyBotRoute } from "@/routes/_app/admin.academy-bot";
import { adminStorageRoute } from "@/routes/_app/admin.storage";
import { adminMediaRoute } from "@/routes/_app/admin.media";
import { adminThemeAuditRoute } from "@/routes/_app/admin.theme-audit";
import { adminThemesRoute } from "@/routes/_app/admin.themes";
import { adminFontsRoute } from "@/routes/_app/admin.fonts";
import { adminEmailRoute } from "@/routes/_app/admin.email";
import { adminEmailCampaignsRoute } from "@/routes/_app/admin.email.campaigns";
import { themeGalleryRoute } from "@/routes/_app/themes";
import { languageRoute } from "@/routes/_app/language";
import { profileFontsRoute } from "@/routes/_app/profile.fonts";
import { profileShortcutsRoute } from "@/routes/_app/profile.shortcuts";
import { profileDeleteAccountRoute } from "@/routes/_app/profile.delete-account";
import { profileTransferSendRoute } from "@/routes/_app/profile.transfer-send";
import { profileTransferReceiveRoute } from "@/routes/_app/profile.transfer-receive";
// SPACE · dominio de cursos
import { catalogRoute } from "@/routes/_app/catalog";
import { catalogCourseRoute } from "@/routes/_app/catalog.$courseId";
import { learnRoute } from "@/routes/_app/learn";
import { learnCourseRoute } from "@/routes/_app/learn.$courseId";
import { leaderboardRoute } from "@/routes/_app/leaderboard";
import { authoringRoute } from "@/routes/_app/authoring";
import { authoringCourseRoute } from "@/routes/_app/authoring.$courseId";
import { certificateRoute } from "@/routes/_app/certificates.$certId";
import { verifyCertificateRoute } from "@/routes/verify.$certId";
// ── F3-J: kit IO Excel/CSV (hub de import/export) ──
import { adminImportExportRoute } from "@/routes/_app/admin.import-export";
// ── fin F3-J ──
// ACADEMY · F4-C: dashboard de analítica de la academia (index)
import { academyIndexRoute } from "@/routes/_app/academy.index";
// ACADEMY · 1C: aula del ALUMNO (índice de sus cohortes + portada de una)
import { classroomIndexRoute } from "@/routes/_app/classroom";
import { classroomDetailRoute } from "@/routes/_app/classroom.$cohortId";
// ACADEMY · F2-A: cohortes + programas
import { academyCohortsRoute } from "@/routes/_app/academy.cohorts";
import { academyTutoringRoute } from "@/routes/_app/academy.tutoring";
// ACADEMY · B1: titularidad (qué pasa si el alumno no ha pagado)
import { academyEntitlementRoute } from "@/routes/_app/academy.entitlement";
import { academyCohortDetailRoute } from "@/routes/_app/academy.cohorts.$cohortId";
import { academyProgramsRoute } from "@/routes/_app/academy.programs";
import { academyProgramDetailRoute } from "@/routes/_app/academy.programs.$programId";
// ACADEMY · F3-D: gente (directorio + expediente + perfil de profesor + autovista)
import { academyPeopleRoute } from "@/routes/_app/academy.people";
// F3-C: notificaciones + anuncios (foros + comms + badges)
import { notificationsRoute } from "@/routes/_app/notifications";
import { academyAnnouncementsRoute } from "@/routes/_app/academy.announcements";
import { academyPersonDetailRoute } from "@/routes/_app/academy.people.$userId";
import { academyTeacherEditorRoute } from "@/routes/_app/academy.teachers.$userId";
import { profileAcademicRoute } from "@/routes/_app/profile.academic";
// ACADEMY · F3-D: página PÚBLICA de profesor (guest-first, fuera de /u/<n>)
import { publicTeacherRoute } from "@/routes/teachers.$orgSlug.$slug";
// ACADEMY · F3-H: billing (caja/facturas/tasas/recibo, admin verificación, alumno)
import { aiTutorRoute } from "@/routes/_app/ai-tutor";
import { crmRoute } from "@/routes/_app/crm";
import { crmSegmentsRoute } from "@/routes/_app/crm.segments";
import { crmTemplatesRoute } from "@/routes/_app/crm.templates";
import { leadDetailRoute } from "@/routes/_app/crm.leads.$leadId";
import { financeRoute } from "@/routes/_app/finance";
import { financePaymentsRoute } from "@/routes/_app/finance.payments";
import { financeInvoicesRoute } from "@/routes/_app/finance.invoices";
import { financeRatesRoute } from "@/routes/_app/finance.rates";
import { receiptRoute } from "@/routes/_app/finance.receipt.$paymentId";
import { adminBillingRoute } from "@/routes/_app/admin.billing";
import { paymentsRoute } from "@/routes/_app/payments";
// ACADEMY · F3-A: horario personal, check-in y ocupación de sede
import { scheduleRoute } from "@/routes/_app/schedule";
import { sessionPlanRoute } from "@/routes/_app/schedule.$sessionId";
// F4-A: trazabilidad (feed de actividad + papelera).
import { activityRoute } from "@/routes/_app/activity";
import { trashRoute } from "@/routes/_app/trash";
import { checkinRoute } from "@/routes/_app/checkin";
// F3-G: clases en vivo (pantalla de acceso / Jitsi embed / grabación)
import { liveSessionRoute } from "@/routes/_app/live.$sessionId";
import { academyCampusOccupancyRoute } from "@/routes/_app/academy.campuses.$campusId";
// ACADEMY · F3-B: página de tareas del alumno
import { assignmentsRoute } from "@/routes/_app/assignments";
// B6 · niveles: el camino del alumno (gateado por academy.progression.path).
import { pathRoute } from "@/routes/_app/path";
// M2: proyecto final (índice + detalle por cohorte).
import { finalProjectIndexRoute } from "@/routes/_app/final-project";
import { finalProjectDetailRoute } from "@/routes/_app/final-project.$cohortId";
// ── AUTONOMY: centro de ayuda in-app (guías por rol + ayuda contextual) ──
import { helpRoute } from "@/routes/_app/help";
import { helpGuideRoute } from "@/routes/_app/help.$guideSlug";
// AUTONOMY: configuración de cobros alcanzable por org_admin (sin rol plataforma).
import { financeSettingsRoute } from "@/routes/_app/finance.settings";
// ── fin AUTONOMY ──

const routeTree = rootRoute.addChildren([
  socialCallbackRoute,
  // Verificación PÚBLICA de certificados (guest-first, fuera de /u/<n>).
  verifyCertificateRoute,
  // F3-D · página PÚBLICA de profesor (guest-first, fuera de /u/<n>).
  publicTeacherRoute,
  authRoute.addChildren([
    loginRoute,
    registerRoute,
    forgotPasswordRoute,
    resetPasswordRoute,
    verifyEmailRoute,
  ]),
  appRoute.addChildren([
    // Fixture de regresión CC-21 (Select/Popover dentro de un Dialog). Solo DEV.
    ...(import.meta.env.DEV ? [cc21ProbeRoute] : []),
    indexRoute, // path: "/" — redirige a /learn
    // SPACE · cursos
    catalogRoute,
    catalogCourseRoute,
    learnRoute,
    learnCourseRoute,
    leaderboardRoute,
    authoringRoute,
    authoringCourseRoute,
    certificateRoute,
    // ACADEMY · F4-C: dashboard de analítica
    academyIndexRoute,
    // ACADEMY · 1C: aula del alumno
    classroomIndexRoute,
    classroomDetailRoute,
    // ACADEMY · F2-A: cohortes + programas
    academyCohortsRoute,
    academyCohortDetailRoute,
    // ACADEMY · M3: panel de tutorías (cola de corrección + reentrega)
    academyTutoringRoute,
    // ACADEMY · B1: titularidad (política de impago + excepciones + simulación)
    academyEntitlementRoute,
    academyProgramsRoute,
    academyProgramDetailRoute,
    // ACADEMY · F3-D: gente + expediente + perfil de profesor + autovista
    academyPeopleRoute,
    notificationsRoute,
    academyAnnouncementsRoute,
    academyPersonDetailRoute,
    academyTeacherEditorRoute,
    profileAcademicRoute,
    // F3-I: CRM / captación (kanban + segmentos + plantillas + detalle de lead)
    aiTutorRoute,
    crmRoute,
    crmSegmentsRoute,
    crmTemplatesRoute,
    leadDetailRoute,
    // F3-H: billing de academia
    financeRoute,
    financePaymentsRoute,
    financeInvoicesRoute,
    financeRatesRoute,
    receiptRoute,
    paymentsRoute,
    // ACADEMY · F3-A: horario / check-in / ocupación
    scheduleRoute,
    // ACADEMY · M5: plan de clase (aula invertida) de una sesión
    sessionPlanRoute,
    activityRoute,
    trashRoute,
    checkinRoute,
    // F3-G: clases en vivo
    liveSessionRoute,
    academyCampusOccupancyRoute,
    // F3-B: tareas del alumno
    assignmentsRoute,
    pathRoute,
    finalProjectIndexRoute,
    finalProjectDetailRoute,
    // ── AUTONOMY: centro de ayuda in-app + config de cobros org-side ──
    helpRoute,
    helpGuideRoute,
    financeSettingsRoute,
    // ── fin AUTONOMY ──
    organizationsRoute,
    organizationDetailRoute,
    invitationsRoute,
    adminRoute.addChildren([
      adminIndexRoute,
      adminUsersRoute,
      adminUserDetailRoute,
      adminInvitesRoute,
      adminAuditLogRoute,
      adminIntegrationsRoute,
      adminFeaturesRoute,
      adminFlagsRoute,
      adminMetricsRoute,
      adminAcademyBotRoute,
      adminStorageRoute,
      adminMediaRoute,
      adminThemeAuditRoute,
      adminThemesRoute,
      adminFontsRoute,
      adminEmailRoute,
      adminEmailCampaignsRoute,
      // F3-H: verificación de pagos / billing
      adminBillingRoute,
      // ── F3-J ──
      adminImportExportRoute,
      // ── fin F3-J ──
    ]),
    themeGalleryRoute,
    languageRoute,
    profileRoute,
    profilesRoute,
    profileFontsRoute,
    profileShortcutsRoute,
    profileDeleteAccountRoute,
    profileTransferSendRoute,
    profileTransferReceiveRoute,
    debugRoute,
  ]),
]);

export const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  // oxlint-disable-next-line eslint(no-magic-numbers)
  defaultPreloadStaleTime: 30_000,
  defaultNotFoundComponent: NotFoundRoute,
});

declare module "@tanstack/solid-router" {
  interface Register {
    router: typeof router;
  }
}
